import LinkAccountForm from "./LinkAccountForm";

export default LinkAccountForm;